import { render, staticRenderFns } from "./ShortcodeTable.vue?vue&type=template&id=7e3473dc"
import script from "./ShortcodeTable.vue?vue&type=script&lang=js"
export * from "./ShortcodeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports